import { Box, Button } from '@mui/material'
import React from 'react'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { focusElemnt, navigation2, navigation3 } from '../../../../common/helper';
import { useTranslation } from '../../../../../i18n/I18nProvider'
const AddandRemoveBtn = (props) => {
    const { addRow, removeRow, index, data, onKeyDownadd = false, onKeyDownRemove = false, pickUpChrg = false } = props
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                <Button
                    id={pickUpChrg ? `addbtn-${index}` : `addbtnD-${index}`}
                    sx={{
                        display: 'flex', alignItems: 'center',
                        '&.MuiButton-root': {
                            minWidth: 'auto !important',
                            padding: '6px 2px !important',
                            textTransform: "capitalize",
                            "&:focus": {
                                color: "black !important"
                            },
                            "&:active": {
                                color: "black !important"
                            }
                        },
                        '&.Mui-disabled': {
                            backgroundColor: 'transparent !important',
                            border: 'none !important'
                        },
                        '& .MuiButton-startIcon': {
                            marginRight: '2px !important'
                        }
                    }}
                    onClick={(e) => addRow(index)}
                    onKeyDown={onKeyDownadd}
                    disabled={data.length >= 4}
                    startIcon={<AddCircleIcon style={{ color: data.length >= 4 ? "#ccc" : '#0086ff', fontSize: '14px' }} />}
                >
                    <span className="blue-color-txt" style={{ color: data.length >= 4 ? "#ccc" : '#0086ff', textDecoration: 'underline', fontWeight: 'bold', fontSize: '12px !important' }}>
                        {tr('gsAdd', 'Add')}
                    </span>
                </Button>

                {index !== 0 && data.length - 1 === index &&
                    <>
                        <span style={{ padding: '0px 2px 2px 2px', fontSize: '14px', fontWeight: 600, color: "#0086FF", }}>
                            |
                        </span>
                        <Button
                            variant="text"
                            id={pickUpChrg ? `removebtn-${index}` : `removebtnW-${index}`}
                            sx={{
                                display: 'flex', alignItems: 'center',
                                '&.MuiButton-root': {
                                    minWidth: 'auto !important',
                                    padding: '6px 2px !important',
                                    textTransform: "capitalize",
                                    "&:focus": {
                                        color: "black !important"
                                    },
                                    "&:active": {
                                        color: "black !important"
                                    }
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: 'transparent !important',
                                    border: 'none !important'
                                },
                                '& .MuiButton-startIcon': {
                                    marginRight: '2px !important'
                                }
                            }}
                            onClick={() => removeRow(index)}
                            onKeyDown={onKeyDownRemove}
                            startIcon={<RemoveCircleIcon style={{ color: '#0086ff', fontSize: '14px' }} />}
                        >
                            <span className="blue-color-txt" style={{ textDecoration: 'underline', fontWeight: 'bold', fontSize: '12px !important' }}>
                                {tr('gsRemove', 'Remove')}
                            </span>
                        </Button>
                    </>
                }
            </Box >
        </>
    )
}

export default AddandRemoveBtn